module.exports = __webpack_public_path__ + "static/media/postcardRetro2.a942c9ad.jpg";